import React from "react";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import { EllipsisVertical } from "lucide-react";
import { Link } from "react-router-dom";

import { useTheme } from "@mui/material";
export const Card = ({ title, value, type, percentage, mode, text }) => {
  const theme = useTheme();
  return (
    <div
      className={`p-2 rounded-xl border shadow-lg flex-1 min-w-[150px] ${
        mode === "dark"
          ? "border-[#292929] bg-neutral-1000"
          : "bg-neutral border-[#292929]"
      } bg-opacity-50`}
      style={{
        boxShadow: "none",
        border: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(2),
        borderRadius: 12,
      }}
    >
      <div className="flex justify-between items-center">
        <div>
          <div
            className={`text-sm ${
              mode === "dark" ? "text-gray-400" : "text-gray-500"
            }`}
          >
            {title}{" "}
          </div>{" "}
          <div className="mt-2 text-3xl font-medium">
            {" "}
            {value}{" "}
            <span
              className={`text-sm ${
                mode === "dark" ? "text-gray-400" : "text-gray-500"
              }`}
            >
              {text}
            </span>{" "}
          </div>{" "}
        </div>{" "}
        <div className="flex gap-2">
          {/* <div
            className={`flex items-center p-1 rounded-3xl border ${
              type === "increase"
                ? mode === "dark"
                  ? "text-green-400 border-green-400"
                  : "text-green-500 border-green-500"
                : mode === "dark"
                ? "text-red-400 border-red-400"
                : "text-red-500 border-red-500"
            }`}
          >
            {type === "increase" ? (
              <TrendingUpOutlinedIcon fontSize="medium" />
            ) : (
              <TrendingDownOutlinedIcon fontSize="medium" />
            )}{" "}
            <span className="ml-2 text-base"> {percentage} % </span>{" "}
          </div>{" "} */}
          {/* <Link to={"/subscription"}>
            <EllipsisVertical color="gray" />
          </Link> */}
        </div>
      </div>{" "}
    </div>
  );
};
export const CustomCard = ({ data, mode, length }) => (
  <div className="flex flex-col md:flex-row gap-6 md:flex-nowrap overflow-x-auto pb-2">
    {" "}
    {data?.map((item, index) => (
      <Card
        key={index}
        title={item.title}
        value={item.value}
        text={item.text}
        type={item.type}
        percentage={item.percentage}
        mode={mode}
      />
    ))}{" "}
  </div>
);
